import React, { useEffect, useState } from 'react';
import './App.css';
import 'fontsource-roboto';
import {
  ThemeProvider,
  StyledEngineProvider,
  createTheme,
} from '@mui/material/styles';
import { Container } from '@mui/material';
import { FirestoreProvider } from 'firebaseHooks/FirestoreContext';
import { FunctionsProvider } from 'firebaseHooks/FunctionsContext';
import { AuthProvider } from 'firebaseHooks/AuthContext';
import { isSsoHost } from 'sso/ssoClient';
import { AnalyticsProvider } from 'firebaseHooks/AnalyticsContext';
import { StorageProvider } from 'firebaseHooks/StorageContext';
import { RemoteConfigProvider } from 'firebaseHooks/RemoteConfigContext';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { connectFunctionsEmulator } from 'firebase/functions';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import CssBaseline from '@mui/material/CssBaseline';
import LoadingPage from 'components/LoadingPage';
import { initializeApp } from 'firebase/app';
import { getAnalytics, setAnalyticsCollectionEnabled } from 'firebase/analytics';
import { initI18next } from './i18n/i18next';
import { getFirebaseFunctions, initializeFirestoreWithSettings } from './utils/firebaseChinaConfig';
import Home from './components/Home';

// Proxy is initialized in utils/firebaseProxy.js at module level

// const host = '192.168.1.129';
const host = 'localhost';

const firebaseConfig = {
  apiKey: 'AIzaSyCa9rLf4xmacQg6xdoxOUxrWFrz7N_34W4',
  authDomain: 'orgs-ws.labox-apps.com',
  projectId: 'labox-ws',
  storageBucket: 'labox-ws.appspot.com',
  messagingSenderId: '669483452439',
  appId: '1:669483452439:web:643c9f04e45b710f297452',
  measurementId: 'G-5N6TZZE0L8',
};

const theme = createTheme({
  palette: {
    primary: {
      main: '#437A89',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#73a9b9',
      contrastText: '#ffffff',
    },
    text: {
      primary: '#3f4d5a',
    },
    info: {
      main: '#437A89',
      contrastText: '#ffffff',
    },
    ourGreen: {
      main: '#99BD5B',
      contrastText: '#ffffff',
    },
    ourOrange: {
      main: '#f4ad45',
      contrastText: '#ffffff',
    },
    gold: {
      main: '#FFD700',
      contrastText: '#ffffff',
    },
    darkgray: {
      main: '#0000008a',
      contrastText: '#ffffff',
    },
    mediumgray: {
      main: '#8585858a',
      contrastText: '#ffffff',
    },
    gray: {
      main: '#d8d8d8',
      contrastText: '#ffffff',
    },
  },
});

// Initialize all Firebase services at once
function initializeFirebaseServices() {
  const app = initializeApp(firebaseConfig);
  const auth = getAuth(app);
  const functions = getFirebaseFunctions(app);
  const storage = getStorage(app);
  const analyticsInstance = getAnalytics(app);
  const firestore = initializeFirestoreWithSettings(app, host);

  // Set up emulators in development
  if (process.env.NODE_ENV === 'development') {
    connectAuthEmulator(auth, `http://${host}:9099`);
    connectFunctionsEmulator(functions, host, 5001);
    connectStorageEmulator(storage, host, 9199);
    setAnalyticsCollectionEnabled(analyticsInstance, false);
  }

  return {
    app, auth, functions, storage, firestore,
  };
}

// Initialize services before rendering
const services = initializeFirebaseServices();

function App() {
  initI18next();
  return (
    <div className="App" style={{ whiteSpace: 'pre-line' }}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <Container>
            <CssBaseline />
            <AuthProvider
              app={services.app}
              ssoEnabled={isSsoHost() || process.env.NODE_ENV === 'development'}
            >
              <RemoteConfigProvider app={services.app}>
                <AnalyticsProvider app={services.app}>
                  <FirestoreProvider firestore={services.firestore}>
                    <FunctionsProvider app={services.app}>
                      <StorageProvider app={services.app}>
                        <Core />
                      </StorageProvider>
                    </FunctionsProvider>
                  </FirestoreProvider>
                </AnalyticsProvider>
              </RemoteConfigProvider>
            </AuthProvider>
          </Container>
        </ThemeProvider>
      </StyledEngineProvider>
    </div>
  );
}

function Core() {
  const [status, setStatus] = useState('initial');

  useEffect(() => {
    if (status === 'initial') {
      setStatus('loaded');
    }
  }, [status]);

  if (status !== 'loaded') {
    return <LoadingPage />;
  }

  return <Home />;
}

export default App;
